export const responseSnowflakeEncryption = {
  data: {
    attributes: {
      password: 'encrypted passwd'
    }
  }
};